import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const portalApi = axios.create({ baseURL: `${BASE}/api` });

portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("op_portal_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong.";
}

export async function uploadVoice(blob) {
  const ext = blob.type.includes("ogg") ? "ogg" : blob.type.includes("mp4") ? "mp4" : "webm";
  const fd = new FormData();
  fd.append("file", blob, `note.${ext}`);
  const { data } = await portalApi.post("/portal/upload/voice", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { url, path }
}

export async function mediaBlobUrl(path) {
  const { data } = await portalApi.get(`/portal/media/${path}`, { responseType: "blob" });
  return URL.createObjectURL(data);
}

export function mediaUrl(path) {
  const t = localStorage.getItem("op_portal_token") || "";
  return `${BASE}/api/portal/media/${path}?token=${encodeURIComponent(t)}`;
}

export async function uploadMedia(file, scope = "cohort", onProgress) {
  const { data: init } = await portalApi.post("/portal/upload/init");
  const { upload_id, chunk_size } = init;
  const total = Math.ceil(file.size / chunk_size) || 1;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, (i + 1) * chunk_size);
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", i);
    fd.append("chunk", blob, file.name);
    await portalApi.post("/portal/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await portalApi.post("/portal/upload/finalize", { upload_id, filename: file.name, content_type: file.type, scope });
  return data; // { path, type, content_type }
}
